/* eslint-disable quotes */
/* eslint-disable semi */
import httpClient from '@/utils/http-client.js';
import { storeActions } from '@store/actions.constants';
import { storeMutations } from '@store/mutations.constants';

const userActions = {
  [storeActions.loginAction]: ({ commit }, payLoad) => {
    return httpClient.post('/user/login', payLoad).then(
      (res) => {
        commit(storeMutations.loginMutation, res);
        return res;
      },
      (err) => {
        commit(storeMutations.loginMutation, err);
        return err.response;
      },
    );
  },
  [storeActions.changePassword]:({commit}, payload) => {
    return httpClient.post('/user/changeUserPassword', payload).then(
      (res) => {
        return res;
      },
      (err) => {
        return err.response;
      },
    );
  },
  [storeActions.userUpdate]: ({ commit }, payLoad) => {
    return httpClient.post('/user/editProfile/' + payLoad.userId, payLoad).then(
      (res) => {
        // commit(storeMutations.setProfileMutation, res);
        return res;
      },
      (err) => {
        // commit(storeMutations.loginMutation, err);
        return err.response;
      },
    );
  },
  [storeActions.getUserById]: ({ commit }, payLoad) => {
    return httpClient.get('/user/getUserDetailsById/' + payLoad.userId).then(
      (res) => {
        commit(storeMutations.loginMutation, res);

        return res;
      },
      (err) => {
        commit(storeMutations.loginMutation, err);
        return err.response;
      },
    );
  },
  [storeActions.forgotPassword]: ({ commit }, payLoad) => {
    return httpClient.post(`/user/forgotPassword`, payLoad).then(
      (res) => {
        commit(storeMutations.setForgotPassword, res);
        return res;
      },
      (err) => {
        commit(storeMutations.loginMutation, err);
        return err.response;
      },
    );
  },
  [storeActions.resetPassword]: ({ commit }, payLoad) => {
    return httpClient
      .post(`/user/resetpassword?token=${payLoad.token}`, payLoad.data)
      .then(
        (res) => {
          commit(storeMutations.setResetPassword, res);
          return res;
        },
        (err) => {
          commit(storeMutations.loginMutation, err);
          return err.response;
        },
      );
  },
  [storeActions.isTokenValidForQentelli]: ({ commit }, payLoad) => {
    return httpClient.post(`/user/isTokenValidForQentelli`, payLoad).then(
      (res) => {
        commit(storeMutations.setIsValidToken, res);
        return res;
      },
      (err) => {
        commit(storeMutations.setIsValidToken, err);
        return err.response;
      },
    );
  },
  [storeActions.getCurrentUserDetails]:({commit})=>{
    return httpClient.get(`/user/getCurrentUserDetails`).then(res=>{
      commit(storeMutations.setCurrentUser,res)
      return res
    },err=>err.response)
  },
  [storeActions.updateCurrentUserDetails]:({commit},payLoad)=>{
    return httpClient.post(`/user/updateCurrentUserDetails`,payLoad).then(
      (res)=>{
        return res;
    },
    (err)=>{
      return err.response;
    }
    );
  }
};
export default { ...userActions };
